import { render, staticRenderFns } from "./CentroMultidisciplinarComponente.vue?vue&type=template&id=f22add3a&scoped=true"
import script from "./CentroMultidisciplinarComponente.vue?vue&type=script&lang=js"
export * from "./CentroMultidisciplinarComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroMultidisciplinarComponente.vue?vue&type=style&index=0&id=f22add3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22add3a",
  null
  
)

export default component.exports